import Index from '@/views/Admin/Index';
import RequestDebug from '@/views/Admin/RequestDebug';
import UserSearch from '@/views/Admin/UserSearch';

const routes = [
  {
    name: 'admin/index',
    path: '/admin',
    component: Index,
    meta: {
      icon: 'crown',
      title: 'Metrics',
    },
  },
  {
    name: 'admin/debug/request',
    path: '/admin/debug/request',
    component: RequestDebug,
    meta: {
      icon: 'bug',
      title: 'Request Debug',
    },
  },
  {
    name: 'admin/users/search',
    path: '/admin/users/search',
    component: UserSearch,
    meta: {
      icon: 'search',
      title: 'Search Users',
    },
  },
];

export default routes;
